import { SetURLSearchParams, useSearchParams } from "react-router-dom";

type UseSearchParamsProps = {
  onSearchParams: (searchParams: URLSearchParams, setSearchParams: SetURLSearchParams) => void
  onError?: (error: unknown) => void
}

export const UseSearchParams = (props: UseSearchParamsProps) => {
  try {
    const [searchParams, setSearchParams] = useSearchParams();
    props.onSearchParams(searchParams, setSearchParams);
  } catch (error) {
    props.onError?.(error);
  }
  return null;
}
